<template>
  <div>
    <!-- Resultado de cada momento contable respectivamente -->
    <b-card no-body class="my-3">
      <b-tabs card>
        <b-tab v-for="res in importPoliza.result" :key="res.id" :title="res.content.poliza.momento">
          <polizas-i-e-card :item="res"></polizas-i-e-card>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import PolizasIECard from '@/components/Polizas/IE/PolizasIECard'

export default {
  name: 'PolizasIETabs',

  components: {
    PolizasIECard
  },

  computed: {
    ...mapState('polizasIEModule', ['importPoliza'])
  }
}
</script>

<style lang="scss" scoped></style>
